import { Box, IconButton, Menu, Typography } from "@mui/material";
import PropTypes from "prop-types";

const colorOptions = [
  "#d32f2f",
  "#ef5350",
  "#fb8c00",
  "#fdd835",
  "#43a047",
  "#1e88e5",
  "#3949ab",
  "#8e24aa",
];

const ColorSelector = ({
  selectedColor,
  colorAnchorEl,
  onColorMenuOpen,
  onColorMenuClose,
  onColorSelect,
  userName = "Ashirbad Panigrahi",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "6px",
            bgcolor: selectedColor,
            border: "1px solid rgba(0,0,0,0.16)",
          }}
        />
        <Typography variant="subtitle1" color="textPrimary">
          {userName}
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={onColorMenuOpen}
        sx={{
          borderRadius: "999px",
          border: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          p: 0.5,
        }}
      >
        <Box
          sx={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            bgcolor: selectedColor,
          }}
        />
      </IconButton>
      <Menu
        anchorEl={colorAnchorEl}
        open={Boolean(colorAnchorEl)}
        onClose={onColorMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box
          sx={{
            p: 1.5,
            display: "grid",
            gridTemplateColumns: "repeat(4, 24px)",
            gap: 1.5,
          }}
        >
          {colorOptions.map((color) => (
            <Box
              key={color}
              onClick={() => onColorSelect(color)}
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                bgcolor: color,
                cursor: "pointer",
                border:
                  selectedColor === color
                    ? "2px solid #fff"
                    : "2px solid transparent",
                boxShadow:
                  selectedColor === color
                    ? "0 0 0 2px #1976d2"
                    : "0 0 0 1px rgba(0,0,0,0.12)",
              }}
            />
          ))}
        </Box>
      </Menu>
    </Box>
  );
};

ColorSelector.propTypes = {
  selectedColor: PropTypes.string.isRequired,
  colorAnchorEl: PropTypes.object,
  onColorMenuOpen: PropTypes.func.isRequired,
  onColorMenuClose: PropTypes.func.isRequired,
  onColorSelect: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

export default ColorSelector;
export { colorOptions };

